import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';

export const selectCommissionType = createSelector(selectJsonQuery, jsonQuery =>
  getTermValue('commission_type')(jsonQuery),
);
